import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
export default function LeafletMap() {
  return (
    <div>
      <MapContainer
        center={[43.71689639550174, 10.391340848027893]}
        zoom={13}
        style={{ width: "100%", height: "900px" }}
        dragging={false}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[43.71689639550174, 10.391340848027893]}>
          <Popup>
            <a
              target="_blank"
              href="https://www.google.com/maps/dir/44.5605994,27.3509896/Largo+Padre+Renzo+Spadoni,+1,+56125+Pisa+PI,+Italy/@43.7328163,10.3906407,12.19z/data=!4m9!4m8!1m1!4e1!1m5!1m1!1s0x12d59174dbb370e9:0x2ddb9ea1c2570375!2m2!1d10.3913243!2d43.7168493"
            >
              SET Office
            </a>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}
